import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { IntlProvider } from 'react-intl';

import { makeSelectLocale } from './selectors';

export const LanguageProvider = (props) => {
  return (
    <IntlProvider locale={props.locale} key={props.locale} messages={props.messages[props.locale]} >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
};

const mapStateToProps = createSelector(
  makeSelectLocale(),
  locale => ({ locale })
);

export default connect(mapStateToProps)(LanguageProvider);
